export const GET_GOODS = "GET_GOODS";
export const GET_GOOD_BY_ID = "GET_GOOD_BY_ID";
export const UPDATE_GOOD = "UPDATE_GOOD";
export const DELETE_GOOD = "DELETE_GOOD";
export const CREATE_GOOD = "CREATE_GOOD";
export const FETCH_GOOD = "FETCH_GOOD";
export const GET_GOOD_SALES = "GET_GOOD_SALES";
export const UPLOAD_GOOD_MEDIUM = "UPLOAD_GOOD_MEDIUM";
export const GET_GOOD_MEDIA = "GET_GOOD_MEDIA";
